<script lang="ts">
    import {
        InlineLoading,
        StructuredList, 
        StructuredListHead, 
        StructuredListBody, 
        StructuredListRow, 
        StructuredListCell,
        Search,
        Select,
        SelectItem,
        DatePicker,
        DatePickerInput,
        Button
    } from "carbon-components-svelte"
    import CaretLeft16 from "carbon-icons-svelte/lib/CaretLeft16";
	import CaretRight16 from "carbon-icons-svelte/lib/CaretRight16";
    import SelectBuilding from "./SelectBuilding.svelte";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant, selectedBuilding} from "../stores";
    import type { Building } from "../models/Building";
    import { onMount } from "svelte";
    import type { Tenant } from "../models/Tenant";
    import Legend from "./Legend.svelte"
    import moment from "moment";

    export let requests: Requests;
    let building: Building;
    $: bookingsToShow = [];
    let tenant: Tenant;
    let promise : Promise<any>;
    $: offset = 0;
    $: size = "100";
    $: until = "";
    $: query = "";
    $: isLastPage = false;

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
        })
        selectedBuilding.subscribe((value) => {
            building = value;
            if(building){
                if(building.id !== ""){
                    promise = getBookingsToShow();
                }
            }
        })
    })

    async function getBookingsToShow(){
        //bookingsToShow = [];
        bookingsToShow = await requests.getBuildingBookings(
            tenant.id, 
            building.id, 
            until.replaceAll('/', ''), 
            offset, 
            Number(size),
            query
        );
        if(bookingsToShow.length > 0 && bookingsToShow.length === Number(size)){
            isLastPage = false;
        }else{
            isLastPage = true;
        }
    }

    function goNext(){
        offset = offset + Number(size);
        promise = getBookingsToShow();
    }

    function goBack(){
        offset = offset - Number(size);
        promise = getBookingsToShow();
    }

    function search(){
        offset = 0;
        promise = getBookingsToShow();
    }
</script>

<SelectBuilding requests={requests} />
{#if building}
    {#if building.id === ""}
    <h6 class="margin-top-32">Selezionare un building</h6>
    {:else}                  
        <h4 class="margin-top-64 margin-bottom-16">
            Prenotazioni building {building.name} del {(moment(new Date())).format('DD-MMM-YYYY')}
        </h4>
        <div style="display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 1rem;">
            <div class="flex-container">
                <div>
                    <DatePicker 
                        datePickerType="single"  
                        dateFormat="Y/m/d"
                        minDate={new Date()} 
                        maxDate={moment(new Date()).add(6, 'd').toDate()}
                        bind:value={until}>            
                    <DatePickerInput labelText="Fino al" placeholder="yyyy/mm/dd" />
                    </DatePicker>
                </div>
                <Button class="button-inline"
                    on:click={() =>{offset = 0; getBookingsToShow()}}>Cerca</Button>
            </div>
            <div>
                <Legend isBookings={true} greenText="In corso" yellowText="In ritardo" redText="Non si è presentato"/>
            </div>  
        </div> 
        <div class="flex-container">
            <Search bind:value={query} placeholder="Cerca per nome, cognome o settore" />
            <Button type="button" on:click={() => search()}>Cerca</Button>    
        </div>   
        <StructuredList condensed>
            <StructuredListHead>
            <StructuredListRow head class="header-row">
                <StructuredListCell head>Data</StructuredListCell>
                <StructuredListCell head>Orario</StructuredListCell>
                <StructuredListCell head>Utente</StructuredListCell>
                <StructuredListCell head>Settore</StructuredListCell>
                <StructuredListCell head>Postazione</StructuredListCell>
                <StructuredListCell head>Stato</StructuredListCell>
            </StructuredListRow>
            </StructuredListHead>
            <StructuredListBody>
                {#await promise}
                    <InlineLoading />
                {:then} 
                {#if bookingsToShow.length > 0} 
                {#each bookingsToShow as booking, index}
                    <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                        <StructuredListCell>{booking.date}</StructuredListCell>
                        <StructuredListCell>{booking.time}</StructuredListCell>
                        <StructuredListCell>{booking.identity}</StructuredListCell>
                        <StructuredListCell>{booking.sector}</StructuredListCell>
                        <StructuredListCell>{booking.seat}</StructuredListCell>
                        <StructuredListCell>
                        {#if booking.status === "NotPresented"}
                        <span class="state-pill error"></span>
                        {:else if booking.status === "IsExpected" || booking.status === "Late"}
                        <span class="state-pill warning"></span>
                        {:else if booking.status === "Entered"}
                        <span class="state-pill good"></span>
                        {/if}
                        </StructuredListCell>
                    </StructuredListRow>
                {/each}  
                {:else}
                <h6 style="margin: 2rem">Nessuna prenotazione</h6>
            {/if}    
                {/await}
            </StructuredListBody>
        </StructuredList>
        <!-- Pagination -->
        <div class="bx--pagination">
            <div class="bx--pagination__left">
                <label id="select-id-pagination-count-label" class="bx--pagination__text" for="select-id-pagination-count">Prenotazioni per pagina:</label>
                <Select class="bx--select bx--select--inline bx--select__item-count" bind:selected={size} on:change={() => {offset = 0; getBookingsToShow()}}>
                    <SelectItem value="10" />
                    <SelectItem value="20" />
                    <SelectItem value="50" />
                    <SelectItem value="100" />
                </Select>
                <span class="bx--pagination__text bx--pagination__items-count">{offset + 1 } - {offset + bookingsToShow.length}</span>
            </div>
            <div class="bx--pagination__right">
                <div class="bx--pagination__control-buttons">
                    <Button 
                        disabled={offset === 0}
                        class="bx--pagination__button bx--pagination__button--backward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-center" 
                        icon={CaretLeft16}
                        iconDescription="Indietro"
                        on:click={goBack}
                    />
                    <Button 
                        disabled={isLastPage}
                        class="bx--pagination__button bx--pagination__button--forward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-end" 
                        icon={CaretRight16} 
                        iconDescription="Avanti"
                        on:click={goNext}
                    />
                </div>
            </div>
        </div>
    {/if}
{:else}
<h6 class="margin-top-32">Selezionare un building</h6>
{/if}